module.exports = __webpack_public_path__ + "img/pdf_icon.d18e1470.svg";